// 文章3数据信息
export default {
  id: 'dayunshan_103',
  content: `# 荞麦叶的功效、作用
  ![荞麦叶的功效、作用1](https://cdn.keihong.tech/img/20250518212428158.jpg)
![荞麦叶的功效、作用2](https://cdn.keihong.tech/img/20250518212431914.jpg)`
}
